import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { FormOverlay } from "shared/ui/overlay/FormOverlay"

import { RoomFormModel } from "features/room-management/types/RoomFormModel"
import { RoomFormTabType } from "features/room-management/types/RoomFormTabType"
import { RoomForm } from "widgets/room/room-form/RoomForm"

export interface RoomOverlayModel extends WithClassName {
  id: string
  formID: string
  headline: string
  prefix?: string
  roomFormModel: RoomFormModel
  autoFocus?: boolean
  submitButtonText?: string
  isLoading?: boolean
  isSubmitting?: boolean
  onCancel?: () => void
  defaultTab?: RoomFormTabType
}

export const RoomOverlay = React.memo(
  ({
    id,
    formID,
    headline,
    prefix,
    roomFormModel,
    autoFocus,
    className,
    submitButtonText,
    isLoading,
    isSubmitting,
    onCancel,
    defaultTab
  }: RoomOverlayModel) => {
    return (
      <FormOverlay
        id={id}
        form={formID}
        prefix={prefix}
        headline={headline}
        onCancel={onCancel}
        className={classNames("room-overlay", className)}
        submitButtonText={submitButtonText}
        isLoading={isLoading}
        isSubmitDisabled={isLoading}
        isDisabled={isSubmitting}
        showCloseButton
      >
        <RoomForm
          id={formID}
          className="overlay-form room-overlay-form"
          autoFocus={autoFocus}
          {...roomFormModel}
          // Must come after the spread: if RoomFormModel ever gains isDisabled,
          // the overlay's in-flight signal must win over anything the model carries.
          isDisabled={isSubmitting}
        >
          <RoomForm.Tabs defaultTab={defaultTab} />
        </RoomForm>
      </FormOverlay>
    )
  }
)
